import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { CloseIcon } from "@talladega/icons";
import { Button } from "../Button";

type Props = {
  iframeSrc: string;
  iframeTitle: string;
  isOpen: boolean;
  onClose(): void;
};

export const IframeModal = ({
  isOpen,
  onClose,
  iframeSrc,
  iframeTitle,
}: Props) => {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500-hsl/75 transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="p-4 pt-16 relative bg-white rounded-lg text-left overflow-auto shadow-xl transform transition-all sm:my-1 w-fit">
                <div className="absolute top-2 right-0">
                  <Button
                    buttonStyle="primary"
                    fill="link"
                    onClick={onClose}
                    size="small"
                    spacing="hug"
                  >
                    <CloseIcon className="h-5 w-5 hover:cursor-pointer" />
                  </Button>
                </div>
                <iframe
                  className="max-w-6xl w-[90vw] h-[75vh]"
                  src={iframeSrc}
                  title={iframeTitle}
                />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default {};
